<!--
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
-->
<script>
import Base from '@views/Base.vue'
import pc from './plugins/SwitchAccount.vue'
import mobile from './plugins/SwitchAccount.mobile.vue'
import { onBeforeMount, getCurrentInstance } from 'vue'

export default {
  extends: Base,
  setup(props, ctx) {
    const vm = getCurrentInstance()

    onBeforeMount(() => {
      vm.proxy.setLoadComponent(pc, mobile)
    })

    return {
      ...Base.setup(props, ctx),
    }
  },
}
</script>
